<template>
    <b-card body-class="wrapper">
        <div v-if="isNetworkError" class="content text-warning">
            <i class="fas fa-4x fa-globe"></i>
            <h1>Network Error</h1>
            <p>
                <strong>There was an error loading data.</strong>
            </p>
            <p>
                Verify you have Internet access and try refreshing the page.
            </p>
            <b-button variant="primary" @click="tryAgain" class="mt-3">
                <i class="fas fa-sync-alt"></i> Try Again
            </b-button>
        </div>
        <div v-else-if="isAuthError" class="content text-info">
            <i class="fas fa-4x fa-sign-in-alt"></i>
            <h1>Authentication Required</h1>
            <p>
                <strong>Your session has expired or authentication is required.</strong>
            </p>
            <p>
                Please refresh the page to sign in again.
            </p>
            <b-button variant="primary" @click="tryAgain" class="mt-3">
                <i class="fas fa-sync-alt"></i> Try Again
            </b-button>
        </div>
        <div v-else class="content text-danger">
            <i class="fas fa-4x fa-exclamation-circle"></i>
            <h1>Unauthorized</h1>
            <p>
                <strong>You do not have access to the requested resource.</strong>
            </p>
            <p v-if="permission">
                Required permission: {{ permission }}
            </p>
            <b-button variant="primary" @click="tryAgain" class="mt-3">
                <i class="fas fa-sync-alt"></i> Try Again
            </b-button>
        </div>
    </b-card>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import userInfoService from "@/util/userInfoService";

@Component({
    name: "UnauthorizedPage"
})
export default class UnauthorizedPage extends Vue {

    async mounted() {
        try {
            const data = await userInfoService.fetchUserInfo();
            if (data) this.tryAgain();
        } catch  {
            //ignore
        }  
    }

    get permission() {
        return this.$route.query.permission;
    }

    get isNetworkError() {
        return this.$route.query.networkError === "1";
    }

    get isAuthError() {
        return this.$route.query.authError === "1";
    }

    get redirectPath() {
        return this.$route.query.redirect;
    }

    tryAgain() {
        if (this.redirectPath) {
            this.$router.replace(decodeURIComponent(this.redirectPath as string));
            return;
        }
        this.$router.replace("/");
    }

}
</script>

<style scoped>
.wrapper {
    height: calc(100vh - 150px);
}

.wrapper,
.content {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    gap: 10px;

    >* {
        margin: 0;
    }
}
</style>